module.exports = __webpack_public_path__ + "static/media/16.58cbdb5b.jpg";